import * as React from "react";
import { EventCategory } from "../../../utils/analytics";
import Badge from "../../ui-library/badge/badge";
import { Colors } from "../../ui-library/design-tokens/colors";
import Image from "../../ui-library/image/image";
import Link from "../../ui-library/link/link";
import styles from "./coin-tickers-table.styles";

interface ExchangeCellProps {
  marketName: string;
  marketLogo?: string;
  marketUrl: string;
  rank: number;
  isDex: boolean;
  eventCategory: EventCategory;
}

const ExchangeCell: React.FC<ExchangeCellProps> = ({
  marketLogo,
  rank,
  marketName,
  marketUrl,
  isDex,
  eventCategory,
}) => (
  <Link
    css={styles.nameContainer}
    to={marketUrl}
    analytics={{
      category: eventCategory,
      action: "Click - Exchange url",
      label: marketName,
    }}
  >
    <div css={styles.nameColLeft}>
      <div css={styles.imageContainer}>
        <Image src={marketLogo} css={styles.image} alt="logo" />
      </div>
      <div css={styles.nameColRank}>{rank}</div>
    </div>
    <div>
      <div css={styles.name}>{marketName}</div>
      <div css={styles.type}>
        {isDex ? <Badge>DEX</Badge> : <Badge color={Colors.Orange}>CEX</Badge>}
      </div>
    </div>
  </Link>
);

export default ExchangeCell;
